import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../shared/user.service';
import { ApplicationNamePipe } from '../../../../../shared/pipe/application-name/user-group.pipe'
import { ApplicationName } from 'src/app/models/ApplicationName';

@Component({
  selector: 'app-manageuser',
  templateUrl: './manageuser.component.html',
  styleUrls: ['./manageuser.component.css']
})

export class ManageuserComponent implements OnInit {
  nogroups: boolean = false;
  isShowNotificationAlert: boolean;
  showAlertMessage: string;
  constructor(private _user: UserService) { }
  users: any;
  masterUsers: any;
  applications: any = [];
  doprdownExpansions: any = {};
  isExtensionExpanded: boolean = false;
  currentApp: string;
  appId: string;
  prevApp: string;
  searchWord: string = '';
  user: any = {};
  userToDelete: any = '';
  isMailError: boolean = false;
  apiReturnMessage: string = "";
  isAscending: boolean = true;
  sortColumn: string = 'name';//default sorting column from backend is name.
  prevSortColumn: string = 'name';
  isAdminUser: boolean = false;
  isSuperUser: boolean = false;
  modifySuperAccess: boolean;
  noAccessToApplication: boolean;
  userGroups: any;
  superUserGroup: string;
  modifyUserGroups: any;
  VALUsers: any = {};

  ngOnInit() {
    this.checkIfUserIsAdmin();
    this.getExternalApplications();
    this.initialiseUser();//user object for Adding and Modifying a user
    this.doprdownExpansions.application = false;
    this.doprdownExpansions.addGroup = false;
  }

  checkIfUserIsAdmin() {
    this.isAdminUser = false;
    this._user.loggendInUser.applicationName.forEach((app) => {
      if (app.userGroup == 'Admin') {
        this.isAdminUser = true;
      }
    });
  }

  checkIfUserIsSuperUser(selectedApplicationId: string) {
    this.isSuperUser = false;
    this._user.loggendInUser.applicationName.forEach((app) => {
      if (app.application == selectedApplicationId && app.userGroup == 'SuperUser') {
        this.isSuperUser = true;
      }
    });
  }

  //searches the user list with the searchword .
  //to reset the search call search(null,'');
  search(event: KeyboardEvent, word: string = '') {
    this.searchWord = event == null ? word : event.target['value'];
    this.users = [];
    this.masterUsers.forEach(element => {
      element.userGroup = element.userGroup == null ? "" :  element.userGroup;
    });
    this.masterUsers.forEach(user => {
      if (user.userEmailId.toLowerCase().includes(this.searchWord.toLowerCase()) || user.name.toLowerCase().includes(this.searchWord.toLowerCase())
        || user.userGroup.toLowerCase().includes(this.searchWord.toLocaleLowerCase())) //if search word contains anything from Emailid,name,usergroup it would then show up in the grid.
        this.users.push(user);
    });
    this.doActualSort();//keeping sort intact after clearing search.
  }

  getUsers(app: any, aapName?: string) {
    this.isAdminUser = false;
    this.isSuperUser = false;
    this.VALUsers = [];
    this.users = [];
    if (aapName === "VAL" || app === "VAL Web App") {
      this.checkIfUserIsAdmin();
      this.appId = "VAL Web App";
      this.getUserGroupsByApplicationId("VAL Web App");
      this._user.getAllUser().subscribe((res) => {
        this.noAccessToApplication = false;
        var jsonString = JSON.stringify(res);//cloning to avoid reference issues
        this.VALUsers = JSON.parse(jsonString); // this list will be renedered in the html
        this.masterUsers = JSON.parse(jsonString);//keeping a copy of users for search operations.
        this.prevApp = app;//to avoid calling api for same application selection.
        this.search(null, this.searchWord);
      }, (err: any) => {
        this.prevApp = app;
        this.VALUsers = [];
        this.masterUsers = [];
        if (err.status == 403) {
          this.noAccessToApplication = true;
        }
      }
      );
    }
    else {
      this.checkIfUserIsSuperUser(app);
      if (app == this.prevApp)//if the currently clicked application is same as the one before clicked.
        return;
      this.appId = app;
      this.getUserGroupsByApplicationId(this.appId);
      this._user.getExternalUsers(app).subscribe((res) => {
        this.noAccessToApplication = false;
        var jsonString = JSON.stringify(res);//cloning to avoid reference issues
        this.users = JSON.parse(jsonString); // this list will be renedered in the html
        this.masterUsers = JSON.parse(jsonString);//keeping a copy of users for search operations.
        this.prevApp = app;//to avoid calling api for same application selection.
        this.search(null, this.searchWord);
      }, (err: any) => {
        this.prevApp = app;
        this.users = [];
        this.masterUsers = [];
        if (err.status == 403) {
          this.noAccessToApplication = true;
        }
      }
      );
    }
  }

  getExternalApplications() {
    this._user.getExternalApplications().subscribe((res) => {
      this.applications = [];
      var userApps = JSON.parse(sessionStorage.userinfo).applicationName;
      var appIds = [];
      userApps.forEach(element => {
        appIds.push(element.application);
      });
      if (!this.isAdminUser) {
        res.forEach(element => {
          if (appIds.includes(element._id))
            this.applications.push(element);//to show only apps user have permission to
        });
      } else {
        this.applications = res;
        this.applications.forEach(element => {
          if (element.name == "VAL")
            element._id = "VAL Web App";
        });
      }
      sessionStorage.setItem("Applications", JSON.stringify(this.applications));
      this.currentApp = this.applications[0].name;
      this.prevApp = '';
      this.getUsers(this.applications[0]._id);//fetches users for the application specified.
    });
  }

  getUserGroupsByApplicationId(app: string) {
    this._user.getUserGroupsByApplicationId(this._user.loggendInUser.userEmailId, app).subscribe((result) => {
      this.userGroups = [];
      this.modifyUserGroups = [];
      this.nogroups = false;

      result.forEach(element => {
        this.userGroups.push(element.group);
      });
      this.superUserGroup = this.userGroups.find(x => x == "SuperUser") == undefined ? this.userGroups.find(x => x == "Admin") : this.userGroups.find(x => x == "SuperUser");
      this.modifyUserGroups = JSON.parse(JSON.stringify(this.userGroups));

      this.checkIfUserIsAdmin();
      var index = this.modifyUserGroups.indexOf(this.superUserGroup == undefined ? "" : this.superUserGroup);
      if (index >= 0) {
        this.modifyUserGroups.splice(index, 1);
      }
    }, (err) => {
      // alert(err.error);
      this.alertNotification(err.error);

      this.nogroups = true;
    });
  }

  initialiseUser(modal: string = '') {
    this.user.userEmailId = '';
    this.user.name = '';
    this.user.applicationName = [];
    this.user.userGroup = '';
    this.doprdownExpansions.addGroup = false;
    if (modal)
      document.querySelector('#' + modal).removeAttribute('visible');
  }

  addUser() {
    var applicationObj = { Application: this.appId, UserGroup: this.user.userGroup };
    this.user.applicationName.push(applicationObj);//setting the users application as the currently selected one from the UI.
    this.user.userEmailId = this.user.userEmailId.toLocaleLowerCase();

    this._user.addExternalUsers(this.user).subscribe((res) => {
      if (res) {
        this.showResponse("User ( " + this.user.name + " ) inserted succesfully.", true);
        this.prevApp = '';
        this.getUsers(this.appId);
        this.initialiseUser('addUserModal');
      }
      else {
        this.showResponse("User ( " + this.user.name + " ) insertion failed.", false);
      }
    })
  }

  deleteUser() {
    this._user.deleteExternalUser(this.userToDelete._id, this.appId).subscribe((res) => {
      if (res) {
        document.getElementById('delete-confirmation').removeAttribute('visible');
        this.showResponse("User (" + this.userToDelete.name + ") deleted successfully.", true);
        this.prevApp = '';
        this.getUsers(this.appId);
      }
      else {
        this.showResponse("User (" + this.userToDelete.name + ") deletion failed.", false);
      }
    });
  }

  deleteConfirmation(user: any) {
    this.userToDelete = user;
    document.getElementById('delete-confirmation').setAttribute('visible', 'true');
  }

  //Initialise the user for modification and shows popup.
  initModify(user: any) {
    this.checkModifySuperAccess(user);
    this.user = JSON.parse(JSON.stringify(user)); //cloning to avoid object reference issues.
    var userGroupPipe = new ApplicationNamePipe();
    this.user.userGroup = userGroupPipe.transform(this.user.applicationName, this.appId);
    document.getElementById('modifyUser').setAttribute('visible', 'true');
  }

  checkModifySuperAccess(userDetails: any) {
    this.modifySuperAccess = false;
    userDetails.applicationName.forEach((app: ApplicationName) => {
      if (app.application == this.appId) {
        if (app.userGroup == "SuperUser" || app.userGroup == "Admin") {
          this.modifySuperAccess = true;
        }
      }
    });
  }

  modifyUser() {
    var applicationArray = {};
    this.user.applicationName.forEach((elem) => {
      if (elem.application == this.appId) {
        elem.userGroup = this.user.userGroup
        applicationArray = elem;
      }
    });
    this.user.applicationName = [];
    this.user.applicationName.push(applicationArray);
    this._user.modifyExternalUser(this.user).subscribe((res) => {
      if (res) {
        this.showResponse("User (" + this.user.name + ") updated successfully.", true);
        this.prevApp = '';
        this.getUsers(this.appId); //resetting and fetching the users.
        this.initialiseUser('modifyUser');
      }
      else {
        this.showResponse("User (" + this.user.name + ") updation failed.", false);
      }
    });
  }

  //Add User popup : Email verification , if email already exists shows the popup and removes the entered email.
  setAddEmail(ev) {
    this.user.userEmailId = ev.target['value'];
    this.masterUsers.forEach(element => {
      if (element.userEmailId.toLowerCase() == this.user.userEmailId.toLowerCase()) {
        document.getElementById("EmailExistsPopup").setAttribute("visible", "true");
        this.user.userEmailId = "";
        ev.target["value"] = "";
      }
    });
    this.isMailError = !this.isEmail(this.user.userEmailId);
  }

  //Email regex
  isEmail(search: string): boolean {
    var serchfind: boolean;
    var regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    serchfind = regexp.test(search);
    console.log(serchfind);
    return serchfind;
  }

  //for handling the X icon in the search input box.
  isReset(ev) {
    if (ev.target.value == "")
      this.search(null, '');
  }

  showResponse(message: string, isSuccess: boolean) {
    this.apiReturnMessage = message;
    if (isSuccess)
      document.getElementById("SuccessPopup").setAttribute("visible", "true");
    else
      document.getElementById("FailurePopup").setAttribute("visible", "true");
  }

  sortUser(sortColumn: string) {
    this.sortColumn = sortColumn;
    if (this.prevSortColumn == this.sortColumn) //if column to be sorted is same as previously sorted column then toggle sort direction
      this.isAscending = !this.isAscending;
    else {
      //if column to be sorted is new then make sort direction ascending and set previous sort column to current column.
      this.isAscending = true;
      this.prevSortColumn = sortColumn;
    }
    this.doActualSort();
  }
  doActualSort() {
    this.users.forEach(element => {
      if (element.name == null)
        element.name = "";
    });
    this.users.sort((valA, valB) => {
      if (this.isAscending)
        return valA[this.sortColumn].toLowerCase().charCodeAt(0) - valB[this.sortColumn].toLowerCase().charCodeAt(0);
      else
        return valB[this.sortColumn].toLowerCase().charCodeAt(0) - valA[this.sortColumn].toLowerCase().charCodeAt(0);
    });
  }

  disableSave(user, appId): boolean {
    var userGroupPipe = new ApplicationNamePipe();
    return user.userGroup == null && userGroupPipe.transform(this.user.applicationName, appId) == null;
  }


  alertNotification(message){
    this.isShowNotificationAlert = true;
    this.showAlertMessage = message;
    setInterval(()=>{
      this.isShowNotificationAlert = false;
    },5000);
  }
}
